import * as React from 'react'
import { ReactElement } from 'react'
import { Dialog, DialogType, IDialogProps, mergeStyles } from '@fluentui/react'
import { useHistory, useLocation } from 'react-router-dom'
import { IBackgroundLocationState, InheritablePropsWithChildren } from '../../../config/appConfig'
import { makeStyles } from '@fluentui/react-components'

export type Dismiss = () => void

type Props = InheritablePropsWithChildren<IDialogProps> & Omit<IDialogProps, 'children'>

const useStyles = makeStyles({
    dialog: {
        // FluentUI uses 1000000 by default, but this dialog must be on top of
        // any existing dialogs.
        zIndex: '1000001',
    },
})

export default function CommandDialog(props: Props): ReactElement {
    const history = useHistory<IBackgroundLocationState>()
    const location = useLocation<IBackgroundLocationState>()
    const styles = useStyles()

    const onDismiss: Dismiss = () => history.push(location.state?.background?.pathname || '/')
    const dialogProps: Omit<IDialogProps, 'children'> = {
        minWidth: '480px',
        hidden: false,
        onDismiss,
        dialogContentProps: {
            type: DialogType.largeHeader,
            ...props.dialogContentProps,
        },
        ...props,
    }

    return (
        <Dialog
            {...dialogProps}
            styles={{ root: mergeStyles(styles.dialog, 'fui-FluentProvider', 'fui-FluentProviderr0') }}
        >
            {props.children(dialogProps)}
        </Dialog>
    )
}
